import { EstadoTomaFisicaENUM, ROUTER_PATHS, useTableFilter, useTableServerSideFiltering } from "@/shared"
import { useFetchGetTomaFisica } from "@/shared/actions/erp/contabilidad/toma_fisica.actions"
import { GeneralTable } from "@/shared/components/ui"
import { useTableColumnsTomaFisica } from "@/shared/hooks/useTableColumnsTomaFisica"
import { ITomaFisica } from "@/shared/interfaces/erp/contabilidad/toma_fisica.interface"
import { Grid } from "@mui/material"
import { useNavigate } from "react-router-dom"

interface TableTomaFisicaProps {
  enable_action?: boolean
  estado_solicitud?: EstadoTomaFisicaENUM
}


export default function TableTomaFisica({
  estado_solicitud = EstadoTomaFisicaENUM.FINALIZADO,
  enable_action = true,
}: TableTomaFisicaProps) {
  const navigate = useNavigate();

  const { columnsTomaFisica } = useTableColumnsTomaFisica()

  const {
    pagination,
    setPagination,
  } = useTableFilter();

  const { columnFilters, setColumnFilters } =
    useTableServerSideFiltering();


  ///* react query

  const { data,
    isLoading,
    isRefetching }
    = useFetchGetTomaFisica({
      estado_solicitud
    })

  return (
    <Grid item xs={12}>
      <GeneralTable<ITomaFisica >
        columns={columnsTomaFisica}
        data={data?.data.data ?? []}
        //
        isLoading={isLoading}
        isRefetching={isRefetching}
        // // search
        enableGlobalFilter={false}
        // onGlobalFilterChange={setGlobalFilter}
        // // pagination
        pagination={pagination}
        onPaging={setPagination}
        rowCount={0}
        // // actions
        actionsColumnSize={50}

        ///* filters - server side
        enableManualFiltering={true}
        columnFilters={columnFilters}
        onColumnFiltersChange={setColumnFilters}
        enableSorting={false}

        // crud
        enableColumnActions={enable_action}
        enableEditing={enable_action}
        onEdit={(data) => {
          navigate(`${ROUTER_PATHS.inventario.tomaFisicaEditarNav}/${data.id_toma_fisica}`)
        }}
        canDelete={false}
        positionActionsColumn='first'

      />
    </Grid>
  )

}

